import { createContext, useContext } from 'react';
import type { ComponentType, ReactNode } from 'react';

import type { IconName } from './iconNames';

export type IconRendererProps = {
  name: IconName;
  size: number;
  color: string;
};

export type IconRenderer = ComponentType<IconRendererProps>;

const IconRendererContext = createContext<IconRenderer | null>(null);

export type IconProviderProps = {
  renderer: IconRenderer;
  children: ReactNode;
};

export function IconProvider({ renderer, children }: IconProviderProps) {
  return <IconRendererContext.Provider value={renderer}>{children}</IconRendererContext.Provider>;
}

export function useIconRenderer(): IconRenderer | null {
  return useContext(IconRendererContext);
}
